import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo-180.png';

const Navbar = ({ onRegister }) => {
    const navigate = useNavigate();

    const handleCtaClick = (type) => {
        // If we are on news page and click CTA, we verify if onRegister is passed (modal opener)
        // If not, we might need to navigate home or handle differently.
        // For now, let's assume this component is used where onRegister is available
        // or we navigate home and pass state? simpler: just open modal if available.
        if (onRegister) {
            onRegister(type);
        } else {
            // Navigate home and maybe trigger modal via URL param in future?
            // For now just go home
            navigate('/');
        }
    };

    return (
        <nav className="navbar glass-panel">
            <div className="container nav-content">
                <Link to="/" className="logo">
                    <img src={logo} alt="AutoMestre" className="logo-img" />
                </Link>
                <div className="nav-links">
                    <Link to="/noticias" className="link-btn">Notícias</Link>
                    <Link to="/instrutor" className="link-btn">Guia do Instrutor</Link>
                    <button onClick={() => onRegister && onRegister('instructor')} className="link-btn">Sou Instrutor</button>
                    <button onClick={() => onRegister && onRegister('student')} className="btn-primary">Quero Habilitação</button>
                </div>
            </div>
            <style>{`
                .navbar {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    z-index: 50;
                    padding: 1rem 0;
                    border-bottom: 1px solid var(--glass-border);
                }
                .nav-content {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .logo {
                    display: flex;
                    align-items: center;
                    text-decoration: none;
                }
                .logo-img {
                    height: 48px;
                    width: auto;
                }
                .nav-links {
                    display: flex;
                    gap: 1.5rem;
                    align-items: center;
                }
                .link-btn {
                    background: transparent;
                    color: var(--text-gray);
                    font-weight: 500;
                    transition: color 0.2s;
                    text-decoration: none;
                    font-size: 1rem;
                    border: none;
                    cursor: pointer;
                }
                .link-btn:hover {
                    color: var(--text-light);
                }
                @media (max-width: 768px) {
                    .link-btn {
                        display: none;
                    }
                }
            `}</style>
        </nav>
    );
};

export default Navbar;
